import { action } from 'typesafe-actions';
import { REPORTS_TYPES, Reports } from './types';

export const getReportsAction = (payload?: any, stores?: any) =>
  action(REPORTS_TYPES.GET_REPORTS_REQUEST, { payload, stores });

export const setReportsAction = (data: Reports) =>
  action(REPORTS_TYPES.SET_DATA_REPORTS, data);

export const setError = (error: any) => action(REPORTS_TYPES.SET_ERROR, error);
